import type { UseMutateFunction } from '@tanstack/react-query';

import { createContext } from 'react';

interface generateAuthTokenResponse {
  token: string;
  expireDate: string;
}

export interface ApiEnvelop {
  requestId: string;
  responseTimeMs: number;
}

export interface SuccessEnvelop<T = unknown> extends ApiEnvelop {
  result: T;
}

export interface GuestAuthContextProps {
  token: string;
  generateAuthToken: UseMutateFunction<
    SuccessEnvelop<generateAuthTokenResponse>,
    Error,
    unknown,
    unknown
  >;

  loading: boolean;
  error: Error | null;
}

export const GuestAuthContext = createContext<GuestAuthContextProps | undefined>(
  undefined,
);
